import React from 'react'
import { UploadFileDropZone } from 'organisms/UploadFileDropzone'
import { Segment } from 'semantic-ui-react'
import IconFrame from 'shared/components/IconFrame'

function InstructionStep({ icon, header, onClick, description }) {
  return (
    <div className="flex items-center flex-1">
      <div className="flex flex-col items-center w-full">
        <IconFrame icon={icon} iconSize={32} frameSize={48} />
        {onClick ? (
          <a className="w-full font-bold text-center !underline" onClick={onClick}>
            {header}
          </a>
        ) : (
          <div className="w-full font-bold text-center">{header}</div>
        )}
        <div className="mt-2 text-center semantic-muted-text">{description}</div>
      </div>
    </div>
  )
}

function InstructionArrow() {
  return (
    <div className="flex items-center justify-center w-9 h-9">
      <i className="fas fa-arrow-right-long text-[32px] semantic-midWhite-color" />
    </div>
  )
}

export default function UploadTranslationPage({
  file,
  setFile,
  fileLoading,
  onUpload,
  setHasError,
  downloadTemplate,
}) {
  return (
    <React.Fragment>
      <Segment className="flex items-center gap-1 semantic-offWhite-bg-color">
        <InstructionStep
          icon="far fa-cloud-download"
          header="Download template CSV"
          onClick={downloadTemplate}
          description="Download all survey text with your current translations."
        />
        <InstructionArrow />
        <InstructionStep
          header="Translate offline"
          onClick={null}
          icon="far fa-file-spreadsheet"
          description="Open the CSV in Sheets or Excel and update the language columns."
        />
        <InstructionArrow />
        <InstructionStep
          icon="far fa-cloud-upload"
          header="Import CSV"
          onClick={null}
          description="We’ll validate and update any fully translated languages."
        />
      </Segment>

      {/* Upload Zone */}
      <div className="mt-5">
        <UploadFileDropZone
          loading={fileLoading}
          onUpload={onUpload}
          setHasError={setHasError}
          instructionHeaderText="Drag and drop your CSV file here"
          description={
            <p className=" mt-11">
              Only fully translated language is considered as ready to import.
              <br />
              Any language columns with missing translations will not be imported.
            </p>
          }
          file={file.data}
          fileName={file.name}
          setFile={setFile}
        />
      </div>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/LanguageImportModal/UploadTranslationPage.js